import React, { useEffect, useRef,  FC } from 'react'
import { Button, message, notification, } from 'antd'
import { YhFormBox } from '@/components/YhFormBox'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from '@/components/YhFormBox/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText } from '@/utils/utils'
import { useInquiryDetailsMode } from './inquiryDetailsModel'
import { IInquiryFormFields } from '../../inquiryTypes'
import { debounce } from 'lodash'
import useGlobalModel from '@/model/globalModel'
import { globalPrompt } from '@/components/message'
import { inquiryService } from '../../inquiryService'
import { SupplierDictCodeEnmu } from '@/types/supplierDictEnums'

export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const formRef = useRef<IYhFormRef>()
    const {
        editFormVal,
        addFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertInquiry,
        updateInquiry,
        getInquiryDetailOne,
        resetEditCatch,
        resetAddCatch,
        saveLoading,
        setSaveLoading,
        editGoodsList,
        addGoodsList
    } = useInquiryDetailsMode()

    const { selectedNavId, replaceNav, findNav } = useNavModel()
    const { fetchSupplierList} = useGlobalModel()

    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        if (!editFormVal.id && mode === 'edit') {
            getInquiryDetailOne(id)
        }
    }, [mode])

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav('2-1') && resetAddCatch()
            !findNav('2-2') && resetEditCatch()
        }
    }, [selectedNavId])

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: IInquiryFormFields) => {}

    //表单提交
    const onSubmit = () => {
        formRef.current
            ?.validateFields()
            .then((D) => {
                //验证商品价格
                const goodsList = mode === 'edit' ? editGoodsList : addGoodsList
                for(let i = 0; i<goodsList.length; i++){
                    const {price, materialName} = goodsList[i]
                    if(!price || price === '0'){
                        return globalPrompt('message', { text: `保存失败:请为${materialName}输入正确的价格！`, type: 'error' })
                    }
                }
                const { ...val } = D
                if (mode === 'edit') {
                    updateInquiry({ ...val, id })
                } else {
                    setSaveLoading(true)
                    insertInquiry(val)
                    .then((res) => {
                        // resetEditCatch()
                        // setSaveLoading(false)
                        // replaceNav('3-1', '3-2', {
                        //     id: res.id,
                        //     mode: 'edit',
                        // })
                        replaceNav(selectedNavId, '3')
                        setSaveLoading(false)
                    })
                    .catch((err) => setSaveLoading(false))
                }
            })
            .catch((err) => {
                notification.open({
                    description: '',
                    message: getFormValidatorErrText(err),
                    duration: 20,
                    type: 'warning',
                    style: {
                        width: 900,
                        marginLeft: 300,
                    },
                    placement: 'topLeft',
                })
            })
    }

    const inquiryOnSubmit = () => {
        globalPrompt('modal', {
            title: '询价单提交',
            type: 'warning',
            text: `询价单提交后讲不能再进行修改`,
            okText: '确定',
            onOk: debounce(
                () =>
                inquiryService.inquiryChange(id).then(() => {
                    globalPrompt('message', { text: '提交成功！', type: 'success' })
                    replaceNav(selectedNavId, '3')
                }),
                500
            ),
            cancelText: '取消',
            onCancel: () => {
            },
        })
    }

    const rightChildren = (
        <>
            {
                (mode === 'add' || editFormVal.status === SupplierDictCodeEnmu.INQUIRY_STATUS_CREATE) &&<Button
                className="mr-5"
                type="link"
                shape="round"
                loading={saveLoading}
                onClick={debounce(() => {
                    onSubmit()
                }, 600)}
            >
                {saveLoading ? '保存中' : '保存'}
            </Button>
            }
            
            {
                mode === 'edit' && editFormVal.status === SupplierDictCodeEnmu.INQUIRY_STATUS_CREATE  && <Button className="mr-5" type="link" shape="round" onClick={inquiryOnSubmit}>
                提交
            </Button>
            }
            <Button className="mr-5" type="link" shape="round" onClick={() => replaceNav(selectedNavId, '3')}>
                返回
            </Button>
        </>
    )
    let newFormVal = mode === 'edit' ? editFormVal : addFormVal
     //单位名称
     const supplierChange = (val: string, option: ISelectOption) => {
        const {label, value} = option
        saveCache({supplierName:label, supplierCode: value })
    }


    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { padding: '10px 0 0 0', marginBottom: '15px' },
        contentClass: 'pr-77',
        rightChildren,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '询价单号',
                fieldName: 'inquiryCode',
                disable: true,
                placeholder: '自动生成',
            },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: '供应商',
                fieldName: 'supplierCode',
                rules: [{ required: true, message: '请输入供应商名称' }],
                onSelectChange: supplierChange,
                selectfetchList: fetchSupplierList,
                defaultQuery: mode === 'edit' ? editFormVal.supplierName : addFormVal.supplierName,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报价人',
                fieldName: 'quotationOfficer',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '备注',
                fieldName: 'note',
            },
           
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '询价人',
                fieldName: 'createUser',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '创建时间',
                fieldName: 'createTime',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '供应商',
                fieldName: 'supplierName',
                hidden: true
            },
            
        ],
    }

    const poFromConfig: IYhFormBox<IInquiryFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: mode === 'edit' ? editFormVal : addFormVal,
        onChange,
        boxs: [baseFormItem],
    }

    return <YhFormBox {...poFromConfig} />
}
